import { Helmet } from 'react-helmet-async'

import useAuth from 'contexts/auth'

const TITLE_SEPARATOR = ' · '

function useConsoleAppTitle(title?: string) {
  const { self } = useAuth()
  const name = self?.workspace?.name

  const devPrefix = process.env.NODE_ENV === 'development' ? '[DEV]' : ''
  const titles = [title, name, 'Integration Console'].filter(Boolean)

  return `${devPrefix} ${titles.join(TITLE_SEPARATOR)}`.trim()
}

export function HeadTitle({ children }: { children?: string | string[] }) {
  const title = useConsoleAppTitle(
    typeof children === 'string' ? children : children?.join(''),
  )
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

export function HeadMetatagsFavicons() {
  return (
    <>
      <link rel='icon' type='image/svg+xml' href='/images/favicon.svg' />
      <link
        rel='icon'
        type='image/png'
        sizes='32x32'
        href='/images/favicon-32x32.png'
      />
      <link
        rel='icon'
        type='image/png'
        sizes='16x16'
        href='/images/favicon-16x16.png'
      />
    </>
  )
}

export function HeadMetatagsGoogleFontsPreconnect() {
  return (
    <>
      <link
        rel='preconnect'
        href='https://fonts.googleapis.com'
        crossOrigin=''
      />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='' />
    </>
  )
}

export function HeadMetatagsGoogleFonts() {
  return (
    <>
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/css2?family=IBM+Plex+Serif&display=swap'
        integrity='sha384-iWOPCPtUDiIpqy9Myw6dZU+1jlE9IgsrGxccg44PiF3iYVEs/fmqGYmkpt8sXb0D'
        crossOrigin='anonymous'
      />
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap'
        integrity='sha384-yMgD24vy4Rp1Wfs5cVEeUEiDQ7N+mekH2tv9h+eSob496Ttcgnbn0jDrC7zaKRWe'
        crossOrigin='anonymous'
      />
      <link
        rel='stylesheet'
        href='https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap'
        integrity='sha384-EpQeZzwbo7EnbuyZZ8qkR+i2QPk1CTBfgvTAKGSpTlWVOsEk8OygDkhP1ZjzUKZw'
        crossOrigin='anonymous'
      ></link>
    </>
  )
}
